import { Component, OnInit, Input } from '@angular/core';

export interface Tab {
  link: string;
  ico: string;
  title: string;
  name: string;
}

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.css']
})
export class TabsComponent implements OnInit {

  @Input('tabs')tabs: Tab[];

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /srv/projects/jsapp/src/app/shared/tabs/tabs.component.ts